export interface DeaScheduleExpirationEntry {
    deaScheduleDrug: number;
    state: string;
    days: number;
}

export const DEA_SCHEDULE_CLASSES: ReadonlyArray<{ value: number; label: string }> = [
    { value: 2, label: "C2" },
    { value: 3, label: "C3" },
    { value: 4, label: "C4" },
    { value: 5, label: "C5" },
];

export const DEFAULT_STATE_KEY = "DEF";
